import React, { useEffect } from 'react'
import { FormControl, InputGroup, Spinner } from 'react-bootstrap'
import { search } from '../utils/api';
import { useUser } from '../context/UserContext';
import { useOrganization } from '../context/OrganizationContext';
import { SearchResults } from '../models/shared/SearchResults';
import { useNavigate } from 'react-router-dom';
import CloseButton from '../components/CloseButton';
import SearchDealsResults from '../components/SearchDealsResults';
import SearchCustomersResults from '../components/SearchCustomersResults';
import { UserRole } from '../models/shared/UserInvitation';

export const MIN_SEARCH_LENGTH = 3;

let timeout: NodeJS.Timeout | null = null;

export default function SearchPage() {
    const searchRef = React.createRef<HTMLInputElement>();
    const [query, setQuery] = React.useState('');
    const [searching, setSearching] = React.useState(false);
    const [allResults, setAllResults] = React.useState<SearchResults | null>(null);
    const { orgId, orgRole } = useOrganization();
    const { getToken } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (searchRef.current) {
            searchRef.current.focus();
        }
    }, [searchRef])

    useEffect(() => {
        if (query.length < MIN_SEARCH_LENGTH) {
            setAllResults(null);
            return;
        }


        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(async () => {
            setSearching(true);

            const token = await getToken();
            const results = await search(token, query, orgId);

            setAllResults(results.hits);

            setSearching(false);
        }, 500);
    }, [query, getToken, orgId])

    useEffect(() => {
        const onEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                if (query) {
                    setQuery('');
                    setAllResults(null);
                } else {
                    navigate(-1)
                }
            }
        }

        document.addEventListener('keydown', onEscape);

        return () => {
            document.removeEventListener('keydown', onEscape);
        }
    }, [query, navigate])

    return (<>
        <div className="d-flex gap-2">

            <InputGroup size='lg' className='rounded-pill'>
                <FormControl ref={searchRef} value={query} onChange={e => setQuery(e.target.value)} />
                <InputGroup.Text>
                    {searching ? <Spinner animation='border' size='sm' /> : <i className='bi bi-search'></i>}
                </InputGroup.Text>
            </InputGroup>

            <CloseButton onClick={() => navigate(-1)} />
        </div>

        {allResults && <div className='d-flex flex-column gap-4 mt-3'>
            <SearchDealsResults hits={allResults.deals} />
            {orgRole !== UserRole.WORKER && <SearchCustomersResults hits={allResults.customers} />}
        </div>}

    </>
    )
}
